import { Option } from "src/util/types/global";
import { BaseConfig } from "../config.interface";
import { Size, Validate } from "../util";

interface IAutoCompleteConfig {
    label?: string;
    delay?: number;
    mode?: 'dropdown' | 'default';
    multiple?: boolean;
    autocomplete?: string;
    optionLabel?: string | ((item: unknown) => unknown);
    optionValue?: string | ((item: unknown) => unknown);
    size: Size | "full";
    validate: Validate;
}
export class AutocompleteConfig extends BaseConfig<IAutoCompleteConfig> implements IAutoCompleteConfig {
    /**
     * Label of the element.
     */
    label?: string;
    /**
     * Search function delay. Useful to debounce async search.
     */
    delay?: number;
    /**
     * Display possible results in a dropdown.
     */
    mode?: "dropdown" | "default";
    /**
     * Allow multiple values
     */
    multiple?: boolean;
    /**
     * Browser autocomplete attribute.
     */
    autocomplete?: string;
    /**
     * Size of the input element.
     * @values "small" | "medium" | "large"
     */
    size: Size | "full";
    /**
     * Show validation status already in `pristine` state or after it has been marked as `dirty`.
     */
    validate: Validate;

    optionLabel?: string | ((item: unknown) => string);
    optionValue?: string | ((item: unknown) => unknown);

    /**
     * @theme Base
     */
    static baseTheme = {
        /**
         * Default configuration. Only allows single value selection.
         */
        Default: new AutocompleteConfig({
            delay:    300,
            mode:     'default',
            multiple: false,
            size:     "medium",
            validate: "dirty",
        }),
        /**
         * Allows multi value selection.
         */
        Multiple: new AutocompleteConfig({
            delay:    300,
            mode:     'default',
            multiple: true,
            size:     "medium",
            validate: "dirty"
        }),

        Tags: new AutocompleteConfig({
            mode:         'dropdown',
            multiple:     true,
            autocomplete: 'off',
            size:         "full",
            validate:     "dirty",
            optionValue:  (item: Option<unknown>) => item,
            optionLabel:  (item: Option<string>) => item.value,
        }),

        Address: new AutocompleteConfig({
            delay:        300,
            mode:         'default',
            multiple:     false,
            autocomplete: 'off',
            size:         "full",
            validate:     "dirty",
            optionLabel:  "displayAddress",
        }),

    };
}
